module.exports = __webpack_public_path__ + "img/xujialu.15e455df.jpg";